// extracted by mini-css-extract-plugin
module.exports = {"container":"Notice_container__9VOh9"};